import React from 'react';
import { useTranslations } from 'next-intl';
import { featureBookingModalConfig } from '@/shared/config/tests/e2e/features/booking';
import { RadioGroup, RadioGroupItem } from '@/shared/ui/radio-group';
interface Props {
  onValueChange: (value: string) => void;
}
export const BookingTypeRadio: React.FC<Props> = props => {
  const {
    onValueChange
  } = props;
  const t = useTranslations();
  return <RadioGroup defaultValue="offline" onValueChange={onValueChange} data-testid={featureBookingModalConfig.ids.bookingTypeRadio} data-sentry-element="RadioGroup" data-sentry-component="BookingTypeRadio" data-sentry-source-file="BookingTypeRadio.tsx">
      <label className="flex items-center gap-2">
        <RadioGroupItem value="offline" data-sentry-element="RadioGroupItem" data-sentry-source-file="BookingTypeRadio.tsx" />
        <span className="text-base">{t('bookingPage.in_medcenter')}</span>
      </label>
      <label className="flex items-center gap-2">
        <RadioGroupItem value="online" data-sentry-element="RadioGroupItem" data-sentry-source-file="BookingTypeRadio.tsx" />
        <span className="text-base">{t('bookingPage.online_consult')}</span>
      </label>
    </RadioGroup>;
};